module.exports = __webpack_public_path__ + "static/media/simmonsInsights.d914a872.png";